<template>
  <div>
    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />
    <b-row>
      <h2>
        {{ $t("checklist.sidebar.Create") + " " + $t("geral.vehicleModel") }}
      </h2>
    </b-row>
    <b-row>
      <b-button @click="voltar()" size="sm">
        {{ $t("geral.back") }}
      </b-button>
    </b-row>

    <b-row class="mt-4">
      <b-col lg="6" md="6" sm="6">
        <vehicle-model :model="model" :modelstate="modelstate" />
      </b-col>
    </b-row>

    <b-row v-if="$store.getters.accessRevisionModelCrud">
      <b-col lg="6" md="6" sm="6">
        <revision-modal :model.sync="model" />
      </b-col>
    </b-row>

    <b-row style="margin-top: 40px">
      <b-button @click="save" size="sm">
        {{ $t("geral.save") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    "vehicle-model": () =>
      import("@/components_rms/System/VehicleModel/VehicleModel.vue"),
    RevisionModal: () =>
      import("@/components_rms/vehicle/Revision/RevisionModal.vue")
  },
  data() {
    return {
      modelstate: [],
      alert: {
        error: "Erro ao criar registro: ",
        success: "Registro criado com sucesso"
      },
      model: {
        name: null,
        size: null,
        brandId: null,
        revisions: []
      }
    };
  },
  methods: {
    save() {
      this.modelstate = [];
      console.log(this.model);
      this.$apiVehicle
        .post("/vehicleModel/create/", this.model)
        .then(response => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.alertDanger.show();
          } else {
            this.$refs.alertSuccess.show();
            this.clearFields();
          }
        })
        .catch(errors => {
          if (errors.response.data.errorCode === 400) {
            this.alert.error = errors.response.data.errorMessage;
            this.$refs.alertDanger.show();
          }
          if (errors.response.status == 400) {
            this.modelstate = errors.response.data.errors;
          }
        });
    },
    clearFields() {
      this.model = {
        name: null,
        size: null,
        brandId: null,
        revisions: []
      };
    },
    voltar() {
      this.$router.go(-1);
    }
  }
};
</script>
